import * as React from 'react';
import styles from "../Service.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLongArrowUp} from "@fortawesome/free-solid-svg-icons";
import {FC} from "react";

export const SelectMachineHint = () => {
    return (
        <div className={styles.emptyFilter}>
            <div className={styles.icons}>
                <FontAwesomeIcon icon={faLongArrowUp}/>
                <FontAwesomeIcon icon={faLongArrowUp}/>
                <FontAwesomeIcon icon={faLongArrowUp}/>
            </div>
            <div className={styles.emptyText}>Please select machine</div>
        </div>);
};

export const NoDataHint: FC<{ message: string }> = ({message}) => {
    return <div className={styles.emptyText}>{message}</div>;
};